import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { Languages } from "./resources/enum";
import cookies from "js-cookie";
import { LANGuAGE_COOKIE } from "./resources/constant";

const nameSpaces = [
  "common",
  "user",
  "registration",
  "assignBuilding",
  "invoice",
  "dashboard",
  "bmcWithRating",
  "validations",
  "homePage",
  "termsAndConditions",
  "privacyPolicy",
];
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [Languages.English, Languages.Arabic],
    // lng:  Languages.English,
    // fallbackLng: Languages.English,
    lng: cookies.get(LANGuAGE_COOKIE) ?cookies.get(LANGuAGE_COOKIE) : Languages.English,
    fallbackLng:  cookies.get(LANGuAGE_COOKIE) ?cookies.get(LANGuAGE_COOKIE) : Languages.English,
    returnObjects: true,
    ns: nameSpaces,
    fallbackNS: nameSpaces,
    defaultNS: [],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
